import styled from 'styled-components';

export const TestimonialContainer = styled.div`
  margin: 0 10%;
  @media (max-width: 720px) {
    margin: 0;
  }
  .head {
    font-size: clamp(22px, 2vw, 48px);
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #675b5a;
    padding: 50px 0 25px;
    @media (max-width: 720px) {
      padding: 35px 0 25px;
    }
  }
  .subHead {
    color: #7e5c5c;
  }
  .container {
    width: 100%;
    display: flex;
    gap: 12px;
    background-color: ${(props) =>
      props.sectionBgColorStart ? props.sectionBgColorStart : ''};
    @media (max-width: 720px) {
      overflow-x: scroll;
      padding: 0 12px;
      &::-webkit-scrollbar {
        display: none;
      }
      padding-bottom: ${(props) => (props.sectionBgColorStart ? '20px' : '')};
    }
    .imageContainer {
      min-width: 225px;
      flex-basis: 50%;
      .mobile {
        display: none;
        @media (max-width: 720px) {
          display: block;
          height: ${(props) =>
            props.showNewTestimonialView ? '100%' : '260px'};
        }
      }
      .desktop {
        display: block;
        @media (max-width: 720px) {
          display: none;
        }
      }
      img {
        width: 100%;
      }
    }
  }
`;
